import { FC } from "react";
import { Grid } from "@mui/material";

import { PageHeader } from "@dzambalaorg/mui-page-layout";

import { Root } from "./styled";

import { AdminSection } from "./infrastructure";

export const Dashboard: FC = () => {
  return (
    <Root>
      <PageHeader message="pages.dashboard.title" />

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}></Grid>
        <Grid item xs={12} md={4}></Grid>
        <Grid item xs={12} md={4}>
          <AdminSection />
        </Grid>
      </Grid>
    </Root>
  );
};
